import { FormField } from "@amzn/awsui-components-react";
import { FormFieldWrapperProps } from "interfaces";

/**
 * A wrapper component for FormField that provides a consistent interface for form fields.
 *
 * @param {string} label - The form field label
 * @param {string} errorText - Error message to display
 * @param {string} warningText - Warning message to display
 * @param {string} description - Description text for the field
 * @param {React.ReactNode} info - Additional info to display
 * @param {React.ReactNode} input - The input element to render
 * @param {string} [testId] - Test identifier for the component
 *
 * @returns {JSX.Element} A FormField component with the provided props
 */
const FormFieldWrapper = ({
    label,
    errorText,
    warningText,
    description,
    info,
    input,
    testId,
}: FormFieldWrapperProps) => {
    return (
        <FormField
            label={label}
            errorText={errorText}
            warningText={warningText}
            description={description}
            info={info}
            stretch={true}
            data-testid={testId}
        >
            {input}
        </FormField>
    );
};

export default FormFieldWrapper;
